import { combineReducers } from 'redux'
import { changePasswordReducer } from './change-password-reducer'
import { GetUserReducer } from './get-user-reducer'
import { resetPasswordReducer } from './reset-password-reducer'

export const UserReducer = combineReducers({
  getUser: GetUserReducer,
  resetPassword: resetPasswordReducer,
  changePassword: changePasswordReducer,
})
